<template>
    <div class="news-wrap">
        <Row>
            <Col :md="brother.length?6:0" span="0">
                <ul class="news-channel-wrap">
                    <template v-for="item in brother">
                        <router-link v-if="item" tag="li" :to="item.to||('/channel/'+item.id)" :key="item.id">
                            {{item.name}}
                            <span class="right-icon">
                                <Icon type="ios-arrow-dropright" />
                            </span>
                        </router-link>
                    </template>
                </ul>
            </Col>
            <Col :md="brother.length?18:24">
                <div style="padding: 0px 20px">
                    <div v-if="channel.id" class="news-channel-title">
                        {{channel.name}}
                    </div>
                    <div class="new-channel-container">
                        <slot></slot>
                    </div>
                </div>
            </Col>
        </Row>
    </div>
</template>
<style lang="less" scoped>
    @import "../../common/mui";
    .news-wrap{
        padding: 20px 0 20px;

        & ul.news-channel-wrap{
            list-style: none;
            padding-bottom: 40px;
            /*border-right: 1px solid lightgrey;*/

            & li{
                font-size: 14px;
                line-height: 50px;
                height: 50px;
                text-align: center;
                padding: 0 30px 0 10px;
                cursor: pointer;
                background-color: @color-thin;
                /*color: white;*/
                position: relative;
                border-bottom: 1px solid whitesmoke;

                & .right-icon{
                    display: block;
                    position: absolute;
                    right: 8px;
                    top:0;
                }

                &.router-link-active,&.router-link-exact-active{
                    background-color: @color-main;
                    color: white;
                }
            }
        }

        & .news-channel-title{
            font-size: 18px;
            font-weight: bolder;
            padding: 10px 20px;
            margin-bottom: 10px;
            border-bottom: 2px solid @color-main;
        }
        & .new-channel-container{
            padding: 0px 20px 10px;
        }
    }
</style>
<script>
    import {mapGetters} from 'vuex'
    export default {
        data() {
            return {
            }
        },
        computed:{
            ...mapGetters('channel',['id','map','mapTree']),
            channel(){
                return this.map[`_${this.id}`]||{};
            },
            brother(){
                if(this.channel.id){
                    return this.mapTree[`_${this.channel.parentId||this.channel.id}`]||[];
                }else{
                    return [];
                }
            }
        },
        components: {},
        methods:{
        }
    }
</script>
